import React, { useEffect, useState } from 'react'
import { Switcher } from '../switcher'
import { IconAlignCenter } from './icons/align-center'
import { IconAlignLeft } from './icons/align-left'
import { IconAlignRight } from './icons/align-right'
import { IconAlignJustify } from './icons/align-justify'
import { AlignType } from './types'

interface AlignmentProps {
  className?: string
  hideJustifyOption?: boolean
  value?: AlignType
  update: (align: AlignType) => void
}
// @TODO: this is example ui for align component

export const Alignment = ({
  hideJustifyOption,
  value = 'center',
  update,
  className,
}: AlignmentProps) => {
  const [activeBtnId, setActiveBtnId] = useState<number>(1)

  const getBtnList = () => {
    let list = [
      { value: 1, content: <IconAlignLeft /> },
      { value: 2, content: <IconAlignCenter /> },
      { value: 3, content: <IconAlignRight /> },
    ]
    if (!hideJustifyOption) {
      list = [...list, { value: 4, content: <IconAlignJustify /> }]
    }
    return list
  }

  const getActiveBtnIdByAlign = (align: AlignType): number => {
    switch (align) {
      case 'left':
        return 1
      case 'center':
        return 2
      case 'right':
        return 3
      case 'justify':
        return 4

      default:
        return 0
    }
  }

  const getAlignByBtnId = (id: number): AlignType => {
    switch (id) {
      case 1:
        return 'left'
      case 2:
        return 'center'
      case 3:
        return 'right'
      case 4:
        return 'justify'

      default:
        return 'left'
    }
  }

  const handleUpdate = (id: number) => {
    update(getAlignByBtnId(id))
  }

  useEffect(() => {
    setActiveBtnId(getActiveBtnIdByAlign(value))
  }, [value])

  return (
    <Switcher
      btnList={getBtnList()}
      update={handleUpdate}
      value={activeBtnId}
      className="p-0"
      wrapperClassName={className}
      btnClassName="flex justify-center items-center h-10 [&>svg]:w-5 [&>svg]:h-5"
    />
  )
}
